import { render, staticRenderFns } from "./FormElement.vue?vue&type=template&id=ff1864da&scoped=true&"
import script from "./FormElement.vue?vue&type=script&lang=js&"
export * from "./FormElement.vue?vue&type=script&lang=js&"
import style0 from "./FormElement.vue?vue&type=style&index=0&id=ff1864da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1864da",
  null
  
)

export default component.exports